export const testIds = {
  showChangeLogButton: 'show-change-log-button',
};
